module.exports = __webpack_public_path__ + "static/media/maths_icon.859bb3e4.png";